import React, { useState, useCallback, useEffect } from 'react';
import { useGlobalFetchingStatus } from '../../scripts/useGlobalState';

// Styles
import './index.scss';

const Loader = () => {
  const pendingRequests = useGlobalFetchingStatus();
  const hasPendingRequests = Boolean(pendingRequests);
  const [showLoader, setShowLoader] = useState(false);

  const useDebouncedEffect = (effect, delay, deps) => {
    const callback = useCallback(effect, [...deps, effect]);

    useEffect(() => {
      const timer = setTimeout(() => {
        callback();
      }, delay);

      return () => clearTimeout(timer);
    }, [callback, delay]);
  };

  useDebouncedEffect(() => {
    setShowLoader(hasPendingRequests);
  }, 50, [hasPendingRequests]);

  return (
    <section className={`eaLoader ${showLoader ? 'eaLoader--show' : ''}`.trim()}>
      <div className='eaLoader__circleOne' />
      <div className='eaLoader__circleTwo' />
    </section>
  );
};

export default React.memo(Loader);